<template>
    <Dialog
        header="Importante"
        :modal="true"
        v-model:visible="abrir_modal"
        :closable="true"
        class="col-12 sm:col-12 md:col-6"
    >
        <div class="solicitud-paso-6-placa">
            <div class="solicitud-paso-6-placa-imagen">
                <img src="/images/car.png" />
            </div>
            <div class="solicitud-paso-6-placa-texto">
                Necesitamos esta información para poder emitir tu recibo
                correspondiente. En caso de que el vehiculo sea más de 1 ingresa
                solo el primero.
            </div>
        </div>
        <template #footer>
            <Button
                label="¡Listo!"
                icon="fas fa-check"
                class="p-button-info p-mr-2 p-button-rounded"
                v-tooltip.bottom="'¡Listo!'"
                @click="abrir_modal = false"
            />
        </template>
    </Dialog>
</template>

<script>
export default {
    name: "solicitud-paso-6-placa-component",
    props: {},
    data() {
        return {
            abrir_modal: false,
        };
    },
    methods: {},
    validations() {},
    mounted() {
        this.emitter.on("solicitud-paso-6-placa", () => {
            this.abrir_modal = true;
        });
    },
};
</script>

<style>
.solicitud-paso-6-placa {
    padding: 0 15px;
    display: flex;
}

.solicitud-paso-6-placa-imagen {
    width: 25%;
}

.solicitud-paso-6-placa-imagen img {
    padding: 10px;
}

.solicitud-paso-6-placa-texto {
    padding: 0 20px;
    width: 75%;
    font-weight: bold;
    font-size: 25px;
}

.icono-mas {
    font-size: 40px !important;
    color: #689f38;
}

.icono-menos {
    font-size: 40px !important;
    color: #d32f2f;
}

@media screen and (max-width: 520px) {
    .solicitud-paso-6-placa {
        flex-wrap: wrap;
    }
    .solicitud-paso-6-placa-imagen,
    .solicitud-paso-6-placa-texto {
        width: 100%;
    }

    .solicitud-paso-6-placa-imagen img {
        margin: 0 auto;
    }
}
</style>
